export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '証明写真',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-historyBaika',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-history',
    title: '職歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'reasonBaika_1',
    title: '自己PR',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reasonBaika_2',
    title: '学生時代',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'requestsBaika',
    title: '志望動機',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'etcBaika',
    title: '研究課題ほか',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'output',
    title: 'ダウンロード',
    previewJumpId: 'close-preview-button-above'
  }
]
